import appConfig from "../../app-config";

const CommonStorage = {
    getItems(key) {
        return localStorage.getItem(`${key}_${appConfig.VUE_APP_COOKIE_NAME}`);
    },
    saveItems(key, value) {
        localStorage.setItem(`${key}_${appConfig.VUE_APP_COOKIE_NAME}`, value);
    },
    clear(key) {
        localStorage.removeItem(`${key}_${appConfig.VUE_APP_COOKIE_NAME}`);
    },
    clearAll() {
        localStorage.clear();
    }
};

export { CommonStorage };